import { render } from "./purchase-details.vue?vue&type=template&id=258dd3a7&scoped=true"
import script from "./purchase-details.vue?vue&type=script&lang=js"
export * from "./purchase-details.vue?vue&type=script&lang=js"

import "./purchase-details.vue?vue&type=style&index=0&id=258dd3a7&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-258dd3a7"]])

export default __exports__